import React, {useRef, useEffect} from 'react';
import { useNavigate, Link } from 'react-router-dom';
import "../Styles/AboutMe.css";
import Header from '../Components/Header';
import Footer from "../Components/Footer"

export default function AboutMe() {
    const navigate = useNavigate();

    const contact = () => {
        navigate("/contact-me");
    }

    const sectionsRef = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
            }
          });
        });
    
    
    
        // Lägg till alla sektioner som ska observeras
        sectionsRef.current.forEach((section) => {
          if (section) observer.observe(section);
        });
    
        return () => {
          sectionsRef.current.forEach((section) => {
            if (section) observer.unobserve(section);
          });
        };
      }, []);
    return (
        <div className="about-me-wrapper">
            <Header />
            <section className="hero-section">
                <div className="hero-section-heading">
                    <h1 className="heading-name fade-in" ref={(el) => (sectionsRef.current[0] = el)}>Philip Jansson</h1>
                    <h1 className="heading-text fade-in" ref={(el) => (sectionsRef.current[1] = el)}>Your Future Employee</h1>
                </div>
            </section>

            <section className='about-section'>
                <div className="about-me-text">
                    <div className="fade-in" ref={(el) => (sectionsRef.current[2] = el)}>
                    <h2 className="title">Who am I?</h2>

                        <p className="summary">
                        My name is Philip Jansson. I'm a cybersecurity consultant, pentester, and developer based in Gothenburg, Sweden. I live with my girlfriend and our son, and outside of family life, most of my time goes into security, coding, building products, and music production.
                        </p>

                        <p className="summary">
                        My path into cybersecurity started through web development. I learned how applications are built, how users interact with them, and how small implementation details can become real security issues. Today, I use that background in penetration testing, bug bounty hunting, and security assessments of web applications, APIs, internal networks, and Active Directory environments.
                        </p>

                        <p className="summary">
                        What drives me is the mix of creativity and technical depth. I enjoy understanding how systems work, finding the edge cases others miss, and turning complex problems into something clear and useful. Whether I’m building an app, testing an application for vulnerabilities, automating a workflow, or producing music, I like being fully immersed in the process.
                        </p>

                    <div className="fade-in" ref={(el) => (sectionsRef.current[3] = el)}>
                   <h2 className='title'>What do I want?</h2>

                    <p className="summary">
                    I want to build a career where I can keep moving deeper into offensive security and vulnerability research. I want to work close to real systems, real businesses, and real risks.
                    </p>

                    <p className="summary">
                    The kind of work I enjoy most is hands on, investigative, and creative. I like digging into how systems are built, understanding the logic behind them, finding the assumptions they rely on, and figuring out where those assumptions break. I want to keep developing that mindset and use it to find vulnerabilities that are not obvious at first glance.
                    </p>

                    <p className="summary">
                    At the same time, I want my work to matter beyond the technical finding itself. I want to help companies understand what they are exposed to, why it matters, and how to protect both their business and their users.I also want to help making security easier to understand, prioritize, and act on.
                    </p>
                    </div>
                    </div>

                    <div className="fade-in" ref={(el) => (sectionsRef.current[4] = el)}>
                    <h2 className='title'>Where do I want to do this?</h2>
                    <p className="summary">
                        I'm based in Gothenburg and I'm open to work remotely, on site and hybrid setups.
                    </p>
                    </div>
                    <div className="fade-in" ref={(el) => (sectionsRef.current[5] = el)}>
                    <h2 className='title'>My own projects</h2>

                    <p className="summary">
                    <span className="project-start">Beatmap</span> is a product I’m building to show what music is being played at bars, clubs, and venues in real time. The system uses small physical sensors placed at venues to capture short audio samples, identify the currently playing song, and send the result to a backend where users can explore live and recently played music on a map.
                    </p>

                    <p className="summary">
                    Beatmap combines several things I enjoy: hardware, software, music, and product development. The goal is to create a music-focused social experience where people can discover venues, songs, and others through what is actually being played and listened to in the real world.
                    </p>

                    <p className="summary">
                    <span className="project-start">Security tooling</span> is another area I spend a lot of time on. I build scripts and tools to support reconnaissance, OSINT, JavaScript analysis, endpoint discovery, fuzzing, and vulnerability research. These projects help me automate repetitive work and find security issues more efficiently during bug bounty hunting and penetration testing.
                    </p>


                    </div>

                    <div className="fade-in" ref={(el) => (sectionsRef.current[6] = el)}>
                    <h2 className='title'>Music Syncs</h2>
                    <p className="summary">
                        I've had the pleasure of creating music for various projects, including two Volvo commercials.
                    </p>

                    <div className="video-wrapper">
                        <div className="video-container fade-in" ref={(el) => (sectionsRef.current[7] = el)}>
                            <h3 className='title'>Be the Bear - Erupt</h3>
                            <iframe 
                                width="100%"  
                                height="315" 
                                src="https://www.youtube.com/embed/Kb-3G--DB7Y" 
                                title="Be The Bear - Erupt (Volvo Winter Story Commercial)" 
                                frameBorder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                referrerPolicy="strict-origin-when-cross-origin" 
                                allowFullScreen
                            ></iframe>
                        </div>

                        </div>

                        <div className="video-container fade-in" ref={(el) => (sectionsRef.current[8] = el)}>
                            <h3 className='title'>Be the Bear - Malibu Lover</h3>
                            <iframe 
                                width="100%" 
                                height="315"
                                src="https://www.youtube.com/embed/0w9_n3AvOi0"
                                title="The New Volvo V40 R-Design"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>


                        <div className="reach-out fade-in" ref={(el) => (sectionsRef.current[9] = el)}>
                    <h2 className='title'>Are you reaching out?</h2>
                    <p className="summary">Does it sound like I could be your future colleague, or are you in need of assistance with development? Or maybe music? Feel free to reach out to me!</p>

                    <button className="reach-out-button" onClick={contact}>I'm reaching out!</button>
                    </div>

                </div>
            </section>
            <Footer />
        </div>
    );
}
